import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/entity',
      component: () => import('@/layouts/App'),
      children: [
        {
          path: 'entity/:name?',
          component: () => import('@/views/Entity/index.vue'),
        },
      ],
    },
    {
      path: '/auth',
      redirect: '/auth/login',
      component: () => import('@/layouts/Auth'),
      children: [
        {
          path: 'login',
          component: () => import('@/views/Auth/Login'),
          meta: {
            isAuth: true,
          },
        },
        {
          path: 'reset',
          component: () => import('@/views/Auth/Reset'),
          meta: {
            isAuth: true,
          },
        },
        {
          path: 'reg',
          component: () => import('@/views/Auth/Reg'),
          meta: {
            isAuth: true,
          },
        },
      ],
    },
  ],
});

router.beforeEach((to, from, next) => {
  if (to.meta.isAuth && store.getters.token) {
    next({ path: '/' });
  } else if (!to.meta.isAuth && !store.getters.token) {
    next({ path: '/auth' });
  } else {
    next();
  }
});

export default router;
